import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'formly-ssn-input',
    template:
        `
        <div class="row">
            <div class="col-10">
                <input [type]="ssnType$ | async" 
                    (input)="onSSNChange($event)"
                    [(ngModel)]="_ssn"
                    placeholder="000-00-0000" 
                    maxlength="11"
                    [formControl]="formControl" [formlyAttributes]="field" class="form-control"
                    >
                </div>
            <div class="col-2" style="padding-top:5px;">
                <a style="font-size:20px;" (click)="onToggleShowSSN()" title="Show / Hide SSN">
                    <fa-icon icon='eye' *ngIf="!showSSN"></fa-icon>
                    <fa-icon icon='eye-slash' *ngIf="showSSN"></fa-icon>
                </a>
            </div>
        </div>
    `,
})
export class FormlySSNInputComponent extends FieldType<FieldTypeConfig> implements OnInit {


    ngOnInit() {
        console.log('FormlySSNInputComponent');
        console.log(this.field);
        this.setInitialValue();
    }

    _ssn = '';
    ssnType$ = new BehaviorSubject('password');
    showSSN = false;

    setInitialValue(){
        let temp:string = this.field?.formControl?.value?.toString();
        if(temp && temp.startsWith('*****')){
            temp = temp.replace('*****', '***-**-');
        }
        this._ssn = temp;
    }

    onToggleShowSSN(){
        this.showSSN = !this.showSSN;
        this.ssnType$.next(this.showSSN ? 'text' : 'password');
    }

    onSSNChange(event:any){
        this._ssn = this.getSSNValidFormat(this._ssn);
    }

    private getSSNValidFormat(ssn: string): string | null {
        if (ssn === null || ssn === undefined) { return null; }

        const pattern = /\d{3}-\d{2}-\d{4}/g;
        let formattedSSN = ssn as any;
        const result = pattern.test(formattedSSN);
        if (!result) {
            formattedSSN = formattedSSN.match(/\d*/g).join('')
                .match(/(\d{0,3})(\d{0,2})(\d{0,4})/).slice(1).join('-')
                .replace(/-*$/g, '');
        }

        return formattedSSN;
    }


}
